export default __webpack_public_path__ + "locales/pl/VersionHistory.json?hash=1a2ff8ba01fc995078ab57084747220c";